module.exports = __webpack_public_path__ + "img/1b.a02186a4.jpg";